module.exports = __webpack_public_path__ + "img/m-baoxiaoguanli.0c4ec6f4.svg";